import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useCursor } from "./CursorContext";
import "./styles/customCursor.css";

const throttle = (fn, limit) => {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last >= limit) {
      last = now;
      fn(...args);
    }
  };
};

const CustomCursor = () => {
  const { visible, isWhite } = useCursor();
  const cursorRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const move = throttle((e) => {
      if (!cursorRef.current) return;
      cursorRef.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
    }, 16);

    window.addEventListener("mousemove", move);
    setMounted(true);

    return () => window.removeEventListener("mousemove", move);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <div
      ref={cursorRef}
      className={`custom-cursor ${visible ? "visible" : ""}`}
      style={{ mixBlendMode: isWhite ? "normal" : "difference" }}
    >
      <div className="plus-icon">+</div>
    </div>,
    document.body
  );
};

export default CustomCursor;
